<template>
    <k-page>
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container size="lg" class="pb-20">
            <k-tabs class="mt-10" tab-class="k-tab-profile" active-tab-class="k-tab-profile-active" :enable-routing="true">
                <k-tab title="Profile" class="mt-10">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <account-information/>
                    </div>
                </k-tab>

                <k-tab title="Change password" class="mt-10">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <change-password/>
                    </div>
                </k-tab>

                <k-tab title="2FA Setup" class="mt-10">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <setup-second-factor/>
                    </div>
                </k-tab>

                <k-tab title="Additional documents" class="mt-10">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <additional-documents
                            :documentSaveUrl="'profile/document'"
                        />
                    </div>
                </k-tab>
            </k-tabs>
        </k-container>
    </k-page>
</template>

<script>
import ProfileHeader from '@investor/components/profile/ProfileHeader'
import AccountInformation from '@product-common/components/investor/AccountInformation'
import AdditionalDocuments from '@product-common/components/user/AdditionalDocuments'
import ChangePassword from '@product-common/components/user/ChangePassword'
import SetupSecondFactor from '@product-common/components/user/SetupSecondFactor'
import KTabs from '@common/components/tabs/KTabs'
import KTab from '@common/components/tabs/KTab'

export default {
        components: {
            KTabs,
            KTab,
            ProfileHeader,
            AccountInformation,
            AdditionalDocuments,
            ChangePassword,
            SetupSecondFactor
        }
    };
</script>
